import React, { Fragment } from "react";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "./table";
import Filters from "./filters";
import AddFileButton from "./load-file-button";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  }
});

class StatsDashboard extends React.Component {
  state = {
    filter: {}
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Typography variant="h5" component="h3">
          Administrador de datos estadísticos
        </Typography>
        <Paper className={classes.root}>
          <Filters
            onSubmit={filter => {
              this.setState({ filter });
            }}
          />
        </Paper>
        <Paper className={classes.root}>
          <Table filter={this.state.filter} size="small"/>
        </Paper>
        <AddFileButton />
      </Fragment>
    );
  }
}

export default withStyles(styles)(StatsDashboard);



// WEBPACK FOOTER //
// ./src/components/stats/index.js